import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "page-sd"
};
const _hoisted_2 = {
  class: "inner custom-scroll"
};
const _hoisted_3 = {
  class: "sd-box"
};
const _hoisted_4 = {
  class: "sd-params"
};
const _hoisted_5 = {
  class: "param-line",
  style: {
    "padding-top": "10px"
  }
};
const _hoisted_6 = {
  class: "form-item-inner"
};
const _hoisted_7 = {
  class: "param-line",
  style: {
    "padding-top": "10px"
  }
};
const _hoisted_8 = {
  class: "form-item-inner"
};
const _hoisted_9 = {
  class: "param-line"
};
const _hoisted_10 = {
  class: "form-item-inner"
};
const _hoisted_11 = {
  class: "param-line"
};
const _hoisted_12 = {
  class: "form-item-inner"
};
const _hoisted_13 = {
  class: "param-line"
};
const _hoisted_14 = {
  class: "form-item-inner"
};
const _hoisted_15 = {
  class: "param-line"
};
const _hoisted_16 = {
  class: "form-item-inner"
};
const _hoisted_17 = {
  class: "param-line"
};
const _hoisted_18 = {
  class: "form-item-inner"
};
const _hoisted_19 = {
  class: "param-line"
};
const _hoisted_20 = {
  class: "form-item-inner"
};
const _hoisted_21 = {
  class: "param-line"
};
const _hoisted_22 = {
  class: "form-item-inner"
};
const _hoisted_23 = {
  class: "param-line"
};
const _hoisted_24 = {
  class: "form-item-inner"
};
const _hoisted_25 = {
  class: "param-line"
};
const _hoisted_26 = {
  class: "form-item-inner"
};
const _hoisted_27 = {
  class: "param-line"
};
const _hoisted_28 = {
  class: "param-line pt"
};
const _hoisted_29 = {
  class: "param-line"
};
const _hoisted_30 = {
  class: "text-info"
};
const _hoisted_31 = {
  class: "submit-btn"
};
const _hoisted_32 = {
  class: "task-list-box pl-6 pr-6 pb-4 pt-4 h-dvh"
};
const _hoisted_33 = {
  class: "job-list-box"
};
const _hoisted_34 = {
  class: "finish-job-list"
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  class: "job-item animate"
};
const _hoisted_37 = {
  class: "image-slot"
};
const _hoisted_38 = {
  class: "err-msg-container"
};
const _hoisted_39 = {
  class: "opt"
};
const _hoisted_40 = {
  key: 1
};
const _hoisted_41 = {
  class: "remove"
};
import { nextTick, onMounted, onUnmounted, ref } from "vue";
import { Delete, DocumentCopy, InfoFilled, Orange } from "@element-plus/icons-vue";
import nodata from "@/assets/img/no-data.png";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage, ElMessageBox } from "element-plus";
import Clipboard from "clipboard";
import { checkSession, getClientId, getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import { getSessionId } from "@/store/session";
import { useSharedStore } from "@/store/sharedata";
import TaskList from "@/components/TaskList.vue";
import BackTop from "@/components/BackTop.vue";
import { showMessageError } from "@/utils/dialog";
import SdTaskView from "@/components/SdTaskView.vue";
export default {
  __name: 'ImageSd',
  setup(__props) {
    const listBoxHeight = ref(0);
    // const paramBoxHeight = ref(0)
    const fullImgHeight = ref(window.innerHeight - 60);
    const showTaskDialog = ref(false);
    const item = ref({});
    const isLogin = ref(false);
    const loading = ref(true);
    const colWidth = ref(220);
    const store = useSharedStore();
    const resizeElement = function () {
      listBoxHeight.value = window.innerHeight - 80;
      // paramBoxHeight.value = window.innerHeight - 200
    };
    resizeElement();
    window.onresize = () => {
      resizeElement();
    };
    const samplers = ["Euler a", "DPM++ 2S a", "DPM++ 2M", "DPM++ SDE", "DPM++ 2M SDE", "UniPC", "Restart"];
    const schedulers = ["Automatic", "Karras", "Exponential", "Uniform"];
    const scaleAlg = ["Latent", "ESRGAN_4x", "R-ESRGAN 4x+", "SwinIR_4x", "LDSR"];
    const params = ref({
      client_id: getClientId(),
      width: 1024,
      height: 1024,
      sampler: samplers[0],
      scheduler: schedulers[0],
      seed: -1,
      steps: 20,
      cfg_scale: 7,
      hd_fix: false,
      hd_redraw_rate: 0.7,
      hd_scale: 2,
      hd_scale_alg: scaleAlg[0],
      hd_steps: 0,
      prompt: "",
      neg_prompt: "nsfw, paintings,low quality,easynegative,ng_deepnegative ,lowres,bad anatomy,bad hands,bad feet"
    });
    const runningJobs = ref([]);
    const finishedJobs = ref([]);
    const router = useRouter();
    // 检查是否有画同款的参数
    const _params = router.currentRoute.value.params["copyParams"];
    if (_params) {
      params.value = JSON.parse(_params);
    }
    const power = ref(0);
    const sdPower = ref(0); // 画一张 SD 图片消耗算力

    const userId = ref(0);
    const clipboard = ref(null);
    onMounted(() => {
      initData();
      clipboard.value = new Clipboard(".copy-prompt-sd");
      clipboard.value.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
      getSystemInfo().then(res => {
        sdPower.value = res.data.sd_power;
        params.value.neg_prompt = res.data.sd_neg_prompt;
      }).catch(e => {
        ElMessage.error("获取系统配置失败：" + e.message);
      });
      store.addMessageHandler("sd", data => {
        // 丢弃无关消息
        if (data.channel !== "sd" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          page.value = 0;
          isOver.value = false;
          fetchFinishJobs();
        }
        nextTick(() => fetchRunningJobs());
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
      store.removeMessageHandler("sd");
    });
    const initData = () => {
      checkSession().then(user => {
        power.value = user["power"];
        userId.value = user.id;
        isLogin.value = true;
        page.value = 0;
        fetchRunningJobs();
        fetchFinishJobs();
      }).catch(() => {});
    };
    const fetchRunningJobs = () => {
      if (!isLogin.value) {
        return;
      }

      // 获取运行中的任务
      httpGet(`/api/sd/jobs?finish=0`).then(res => {
        runningJobs.value = res.data.items;
      }).catch(e => {
        ElMessage.error("获取任务失败：" + e.message);
      });
    };
    const page = ref(0);
    const pageSize = ref(20);
    const isOver = ref(false);
    // 获取已完成的任务
    const fetchFinishJobs = () => {
      if (!isLogin.value || isOver.value === true) {
        return;
      }
      loading.value = true;
      page.value = page.value + 1;
      httpGet(`/api/sd/jobs?finish=1&page=${page.value}&page_size=${pageSize.value}`).then(res => {
        if (res.data.items.length < pageSize.value) {
          isOver.value = true;
        }
        const imageList = res.data.items;
        for (let i = 0; i < imageList.length; i++) {
          imageList[i]["img_thumb"] = imageList[i]["img_url"] + "?imageView2/4/w/300/h/0/q/75";
        }
        if (page.value === 1) {
          finishedJobs.value = imageList;
        } else {
          finishedJobs.value = finishedJobs.value.concat(imageList);
        }
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取任务失败：" + e.message);
      });
    };

    // 创建绘图任务
    const promptRef = ref(null);
    const generate = () => {
      if (params.value.prompt === "") {
        promptRef.value.focus();
        return ElMessage.error("请输入绘画提示词！");
      }
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      if (!params.value.seed) {
        params.value.seed = -1;
      }
      params.value.session_id = getSessionId();
      httpPost("/sd/image", params.value).then(() => {
        ElMessage.success("绘画任务推送成功，请耐心等待任务执行...");
        power.value -= sdPower.value;
        fetchRunningJobs();
      }).catch(e => {
        ElMessage.error("任务推送失败：" + e.message);
      });
    };
    const showTask = row => {
      item.value = row;
      showTaskDialog.value = true;
    };
    const copyParams = row => {
      params.value = row.params;
      showTaskDialog.value = false;
    };
    const removeImage = item => {
      ElMessageBox.confirm("此操作将会删除任务和图片，继续操作码?", "删除提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/sd/remove", {
          id: item.id
        }).then(() => {
          ElMessage.success("任务删除成功");
          page.value = 0;
          isOver.value = false;
          fetchFinishJobs();
        }).catch(e => {
          ElMessage.error("任务删除失败：" + e.message);
        });
      }).catch(() => {});
    };

    // 发布图片到作品墙
    const publishImage = (item, action) => {
      let text = "图片发布";
      if (action === false) {
        text = "取消发布";
      }
      httpGet("/sd/publish", {
        id: item.id,
        action: action
      }).then(() => {
        ElMessage.success(text + "成功");
        item.publish = action;
        page.value = 0;
        isOver.value = false;
        item.publish = action;
      }).catch(e => {
        ElMessage.error(text + "失败：" + e.message);
      });
    };
    const isGenerating = ref(false);
    const generatePrompt = () => {
      if (params.value.prompt === "") {
        return showMessageError("请输入原始提示词");
      }
      isGenerating.value = true;
      httpPost("/prompt/image", {
        prompt: params.value.prompt
      }).then(res => {
        params.value.prompt = res.data;
        isGenerating.value = false;
      }).catch(e => {
        showMessageError("生成提示词失败：" + e.message);
        isGenerating.value = false;
      });
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_image = _resolveComponent("el-image");
      const _component_v3_waterfall = _resolveComponent("v3-waterfall");
      const _component_el_empty = _resolveComponent("el-empty");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[23] || (_cache[23] = _createElementVNode("h2", null, "Stable Diffusion 创作中心", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        model: params.value,
        "label-width": "80px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form_item, {
          label: "采样方法"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_select, {
            modelValue: params.value.sampler,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.sampler = $event),
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(samplers, item => {
              return _createVNode(_component_el_option, {
                label: item,
                value: item,
                key: item
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "出图效果比较好的一般是 Euler 和 DPM 系列算法",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form_item, {
          label: "采样调度"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_select, {
            modelValue: params.value.scheduler,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.scheduler = $event),
            style: {
              "width": "150px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(schedulers, item => {
              return _createVNode(_component_el_option, {
                label: item,
                value: item,
                key: item
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "推荐自动或者 Karras",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form_item, {
          label: "图片尺寸"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: params.value.width,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.value.width = $event),
                modelModifiers: {
                  number: true
                },
                placeholder: "图片宽度"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: params.value.height,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => params.value.height = $event),
                modelModifiers: {
                  number: true
                },
                placeholder: "图片高度"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_form_item, {
          label: "迭代步数"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_input, {
            modelValue: params.value.steps,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => params.value.steps = $event),
            modelModifiers: {
              number: true
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "值越大则代表细节越多，同时也意味着出图速度越慢",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_form_item, {
          label: "引导系数"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_input, {
            modelValue: params.value.cfg_scale,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => params.value.cfg_scale = $event),
            modelModifiers: {
              number: true
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "提示词引导系数，图像在多大程度上服从提示词<br/> 较低值会产生更有创意的结果",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_form_item, {
          label: "随机因子"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_input, {
            modelValue: params.value.seed,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => params.value.seed = $event),
            modelModifiers: {
              number: true
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "随机数种子，相同的种子会得到相同的结果<br/> 设置为 -1 则每次随机生成种子",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_tooltip, {
            content: "使用随机数",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              onClick: _cache[7] || (_cache[7] = $event => params.value.seed = -1),
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(Orange))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_form_item, {
          label: "高清修复"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_switch, {
            modelValue: params.value.hd_fix,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => params.value.hd_fix = $event),
            style: {
              "--el-switch-on-color": "#47fff1"
            },
            size: "large"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "先以较小的分辨率生成图像，接着方法图像<br />然后在不更改构图的情况下再修改细节",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              style: {
                "margin-left": "10px",
                "top": "12px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_form_item, {
          label: "重绘幅度"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_slider, {
            modelValue: params.value.hd_redraw_rate,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => params.value.hd_redraw_rate = $event),
            modelModifiers: {
              number: true
            },
            max: 1,
            step: 0.1,
            style: {
              "width": "180px",
              "--el-slider-main-bg-color": "#47fff1"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "决定算法对图像内容的影响程度<br />较大的值将得到越有创意的图像",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_form_item, {
          label: "放大算法"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_select, {
            modelValue: params.value.hd_scale_alg,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => params.value.hd_scale_alg = $event),
            style: {
              "width": "176px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(scaleAlg, item => {
              return _createVNode(_component_el_option, {
                label: item,
                value: item,
                key: item
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "高清修复放大算法，主流算法有Latent和ESRGAN_4x",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_form_item, {
          label: "放大倍数"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_input, {
            modelValue: params.value.hd_scale,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => params.value.hd_scale = $event),
            modelModifiers: {
              number: true
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "随机数种子，相同的种子会得到相同的结果<br/> 设置为 -1 则每次随机生成种子",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_form_item, {
          label: "迭代步数"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_input, {
            modelValue: params.value.hd_steps,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => params.value.hd_steps = $event),
            modelModifiers: {
              number: true
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tooltip, {
            content: "重绘迭代步数，如果设置为0，则设置跟原图相同的迭代步数",
            "raw-content": "",
            placement: "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "info-icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })])], 512), [[_vShow, params.value.hd_fix]]), _createElementVNode("div", _hoisted_27, [_withDirectives(_createVNode(_component_el_input, {
          modelValue: params.value.prompt,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => params.value.prompt = $event),
          autosize: {
            minRows: 4,
            maxRows: 6
          },
          type: "textarea",
          ref_key: "promptRef",
          ref: promptRef,
          placeholder: "请在此输入绘画提示词，您也可以点击下面的提示词助手生成绘画提示词"
        }, null, 8, ["modelValue"]), [[_directive_loading, isGenerating.value]])]), _createVNode(_component_el_row, {
          class: "text-info"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "generate-btn",
            size: "small",
            onClick: generatePrompt,
            color: "#5865f2",
            disabled: isGenerating.value
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createElementVNode("i", {
              class: "iconfont icon-chuangzuo",
              style: {
                "margin-right": "5px"
              }
            }, null, -1), _createElementVNode("span", null, "生成专业绘画指令", -1)])),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_28, [_cache[19] || (_cache[19] = _createElementVNode("span", null, "反向提示词：", -1)), _createVNode(_component_el_tooltip, {
          content: "不希望出现的元素，下面给了默认的起手式",
          placement: "right"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "info-icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_input, {
          modelValue: params.value.neg_prompt,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => params.value.neg_prompt = $event),
          autosize: {
            minRows: 4,
            maxRows: 6
          },
          type: "textarea",
          placeholder: "反向提示词"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_cache[20] || (_cache[20] = _createTextVNode("单次绘图消耗 ")), _createVNode(_component_el_text, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(sdPower.value) + "算力，", 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_cache[21] || (_cache[21] = _createTextVNode("当前可用 ")), _createVNode(_component_el_text, {
              type: "warning"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(power.value) + "算力", 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_el_button, {
        type: "primary",
        dark: false,
        round: "",
        onClick: generate
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("立即生成")])),
        _: 1
      })])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", {
        class: "task-list-inner",
        style: _normalizeStyle({
          height: listBoxHeight.value + 'px'
        })
      }, [_createElementVNode("div", _hoisted_33, [_cache[31] || (_cache[31] = _createElementVNode("h2", {
        class: "text-xl"
      }, "任务列表", -1)), _createVNode(TaskList, {
        list: runningJobs.value
      }, null, 8, ["list"]), finishedJobs.value.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[30] || (_cache[30] = _createElementVNode("h2", {
        class: "text-xl"
      }, "创作记录", -1)), _createElementVNode("div", _hoisted_34, [finishedJobs.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createVNode(_component_v3_waterfall, {
        id: "waterfall",
        list: finishedJobs.value,
        srcKey: "img_thumb",
        gap: 20,
        bottomGap: -10,
        colWidth: colWidth.value,
        distanceToScroll: 100,
        isLoading: loading.value,
        isOver: isOver.value,
        onScrollReachBottom: _cache[15] || (_cache[15] = $event => fetchFinishJobs())
      }, {
        default: _withCtx(slotProp => [_createElementVNode("div", _hoisted_36, [slotProp.item.progress === 101 ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0
        }, {
          error: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_cache[26] || (_cache[26] = _createElementVNode("div", {
            class: "title"
          }, "任务失败", -1)), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_popover, {
            title: "错误详情",
            trigger: "click",
            width: 250,
            content: slotProp.item['err_msg'],
            placement: "top"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              type: "info"
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("详情")])),
              _: 1
            })]),
            _: 2
          }, 1032, ["content"]), _createVNode(_component_el_button, {
            type: "danger",
            onClick: $event => removeImage(slotProp.item)
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])])])])]),
          _: 2
        }, 1024)) : (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_el_image, {
          src: slotProp.item['img_thumb'],
          onClick: $event => showTask(slotProp.item),
          fit: "cover",
          loading: "lazy"
        }, null, 8, ["src", "onClick"]), _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_button, {
          type: "danger",
          icon: _unref(Delete),
          onClick: $event => removeImage(slotProp.item),
          circle: ""
        }, null, 8, ["icon", "onClick"]), slotProp.item.publish ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "warning",
          onClick: $event => publishImage(slotProp.item, false),
          circle: ""
        }, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [_createElementVNode("i", {
            class: "iconfont icon-cancel-share"
          }, null, -1)])),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "success",
          onClick: $event => publishImage(slotProp.item, true),
          circle: ""
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [_createElementVNode("i", {
            class: "iconfont icon-share-bold"
          }, null, -1)])),
          _: 2
        }, 1032, ["onClick"]))])]))])]),
        footer: _withCtx(() => _cache[29] || (_cache[29] = [_createElementVNode("div", {
          class: "no-more-data"
        }, [_createElementVNode("span", null, "没有更多数据了"), _createElementVNode("i", {
          class: "iconfont icon-face"
        })], -1)])),
        _: 1
      }, 8, ["list", "colWidth", "isLoading", "isOver"])])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "暂无记录"
      }, null, 8, ["image"]))])], 64)) : _createCommentVNode("", true)])], 4), _createVNode(BackTop, {
        right: 30,
        bottom: 30
      })])]), _createVNode(SdTaskView, {
        modelValue: showTaskDialog.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => showTaskDialog.value = $event),
        data: item.value,
        onDrawSame: copyParams,
        onClose: _cache[17] || (_cache[17] = $event => showTaskDialog.value = false)
      }, null, 8, ["modelValue", "data"])])]);
    };
  }
};